import { render, staticRenderFns } from "./SocioNuevoPassword.vue?vue&type=template&id=81f76208&"
import script from "./SocioNuevoPassword.vue?vue&type=script&lang=js&"
export * from "./SocioNuevoPassword.vue?vue&type=script&lang=js&"
import style0 from "./SocioNuevoPassword.vue?vue&type=style&index=0&id=81f76208&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports